var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExclamationCircleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.97069,
    cy: 6.03549,
    rx: 4.8,
    ry: 4.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 9.31444 9.31348 12 6 12C2.68652 12 0 9.31444 0 6C0 2.68749 2.68652 0 6 0C9.31348 0 12 2.68749 12 6ZM6 7.20968C5.38536 7.20968 4.8871 7.70794 4.8871 8.32258C4.8871 8.93722 5.38536 9.43548 6 9.43548C6.61464 9.43548 7.1129 8.93722 7.1129 8.32258C7.1129 7.70794 6.61464 7.20968 6 7.20968ZM4.94339 3.20937L5.12286 6.49969C5.13126 6.65366 5.25856 6.77419 5.41275 6.77419H6.58725C6.74144 6.77419 6.86874 6.65366 6.87714 6.49969L7.0566 3.20937C7.06568 3.04306 6.93327 2.90323 6.76672 2.90323H5.23326C5.06671 2.90323 4.93432 3.04306 4.94339 3.20937Z",
    fill: "#0381B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamationCircleBlue);
export default __webpack_public_path__ + "static/media/icon-exclamation-circle-blue.984df9b6196240b57947b2f6fbee1abf.svg";
export { ForwardRef as ReactComponent };